import formatCurrency from 'src/util/formatCurrency';
import { v4 as uuid } from 'uuid';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

/**
 * Renders a table with rows containing asset information and their corresponding values.
 * @param {string}    className     - A class name to be applied to the outermost container element.
 * @param {function}  onRowClick    - A function to be called when a row is clicked.
 * @param {boolean}   onColumnClick - A boolean to indicate if component is being rendered on the review page
 * @param {Array}     rows          - An array of objects containing asset information. Each object should have a 'name' and 'value' property.
 * @param {string}    total         - A string representing the total value of all assets.
 */

const columns = [
  {
    field: 'yearsOfDeliquency',
    flex: 1,
    headerName: 'Years of Delinquency',
  },
  {
    field: 'taxes',
    flex: 1,
    headerName: 'Taxes',
  },
  {
    field: 'penaltyFees',
    flex: 1,
    headerName: 'Penalty Fees',
  },
  {
    field: 'interest',
    flex: 1,
    headerName: 'Interest',
  },
  {
    field: 'total',
    flex: 1,
    headerName: 'Total',
  },
];

function CustomFooterStatusComponent({ total = 0 }) {
  return <Box sx={{ p: 1, display: 'flex' }}>Total: {formatCurrency(total)}</Box>;
}

function CustomToolbar({ addAsset = () => {} }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'end',
        p: 0.5,
        pb: 0,
      }}
    >
      <Button onClick={addAsset} endIcon={<AddIcon />} variant="outlined">
        Add
      </Button>
    </Box>
  );
}

export default function ValueTaxDataTable({
  addAsset,
  className = '',
  onRowClick = () => {},
  toolbar,
  rows = [],
  total = '0',
}) {
  return (
    <div className={`h-[25rem] ${className}`}>
      <DataGrid
        columns={columns}
        components={{
          Footer: () => <CustomFooterStatusComponent total={total} />,
          Toolbar: () => (toolbar ? <CustomToolbar addAsset={addAsset} /> : null),
        }}
        getRowId={() => uuid()}
        onRowClick={onRowClick}
        rows={rows}
        sx={{
          '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
            my: '1rem',
            height: '100%',
          },
        }}
      >
        PropertyValueAndTaxInfo
      </DataGrid>
    </div>
  );
}
